<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box new_game_popup modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modal_new_game_start }}</h1>
        <p>{{ getTranslations.home_modal_new_game_start_title }}</p>
        <h2>{{ getTranslations.home_modal_new_game_start_what_do }}</h2>
        <div class="games_selection_container">
          <div class="games_selection_row">
            <div :class="['game_box logic', gameType === 'LOGIC' ? 'selected_game_mode' : '']" @click.prevent="gameType = 'LOGIC'">
              <img src="static/images/games/icon-logic.png">
              <p>{{ getTranslations.home_modal_game_logic }}</p>
            </div>
            <div :class="['game_box memory', gameType === 'MEMORY' ? 'selected_game_mode' : '']" @click.prevent="gameType = 'MEMORY'">
              <img src="static/images/games/icon-memory.png">
              <p>{{ getTranslations.home_modal_game_memory }}</p>
            </div>
          </div>
          <div class="games_selection_row">
            <div :class="['game_box attention', gameType === 'ATTENTION' ? 'selected_game_mode' : '']" @click.prevent="gameType = 'ATTENTION'">
              <img src="static/images/games/icon-attention.png">
              <p>{{ getTranslations.home_modal_game_attention }}</p>
            </div>
            <div class="game_box mixed" v-if="false" @click.prevent="gameType = 'MIXED'">
              <img src="static/images/games/icon-mixed.png">
              <p>{{ getTranslations.home_modal_game_mixed }}</p>
            </div>
          </div>
        </div>
        <h1>{{ getTranslations.home_modal_game_choose_your_level }}</h1>
        <div class="newGame_buttons" v-if="hasGameMode">
          <button type="button" :class="['newGame_btn', gameMode === 'EASY' ? 'selected_dif_btn' : '']" @click.prevent="gameMode = 'EASY'">
            <img src="static/images/games/easy0.svg">
            <p>{{ getTranslations.home_modal_game_easy }}</p>
          </button>
          <button type="button" :class="['newGame_btn', gameMode === 'HARD' ? 'selected_dif_btn' : '']" @click.prevent="gameMode = 'HARD'">
            <img src="static/images/games/hard0.svg">
            <p>{{ getTranslations.home_modal_game_hard }}</p>
          </button>
        </div>
        <button type="" @click.prevent="playGameMethod" v-if="!!gameType && !!gameMode">
          {{ getTranslations.home_modal_game_new_game }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import NewGameMixin from '@/common/mixins/home';

export default {
  name: 'new-game-modal',
  mixins: [NewGameMixin],
  props: {
    hasGameMode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      gameType: null,
      gameMode: 'EASY',
    };
  },
  beforeDestroy() {
    this.storeModalForHomePage(null);
    this.storeModalForStore(null);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForStore',
    ]),
    playGameMethod() {
      this.playGame(this.gameType, this.gameMode);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/pregame/NewGameModal.vue